<template>
  <PageTemplate class="thanks">
    <BlockContainer class="pb-5 pt-5">
      <div class="d-flex flex-column align-items-center text-center">
        <HusleieLogo />
        <h3 class="mt-5">Takk for at du bruker Husleie.no</h3>
      </div>

      <div class="thanks__benefitCards mt-5">
        <Card header="Basic" amount="99" :benefits="benefitsBasic" />
        <Card header="Premium" amount="199" :benefits="benefitsPremium" />
      </div>

      <div class="thanks__detailedBenefits">
        <h4 class="mb-4">Detaljert innhold i abonnementsplanene</h4>
        <Detailed :benefits="detailedBenefits" class="mt-5" />
      </div>
    </BlockContainer>

    <BlockContainer class="thanks__tenancies">
      <div class="d-flex align-items-center mb-4">
        <i class="h5 budicon-email" />
        <h5 class="ml-4">Hvilke leieforhold ønsker du å oppgradere?</h5>
      </div>
      <p>
        Leieforholdene listet under er ikke registrert med forvaltningsabonnement fra Husleie.no. Klikk oppgrader for å
        velge mellom Basic (99 / mnd) eller Premium (199 / mnd). Du kan lese mer om våre abonnementer
        <a href="https://www.husleie.no/priser/">her</a>. Du kan også velge å skjule leieforholdet fra listen.
      </p>

      <Tenancies
        :tenancies="filteredTenancies"
        :shouldShowRentalObjectCheckbox="false"
        :shouldShowPaymentStatus="false"
        :shouldShowNotifications="false"
        class="mt-5"
      />
    </BlockContainer>
  </PageTemplate>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import PageTemplate from '@/components/PageTemplate.vue';
import BlockContainer from '@/components/BlockContainer.vue';
import HusleieLogo from '@/components/HusleieLogo.vue';
import Card from '@/components/subscription/Card.vue';
import Detailed from '@/components/subscription/Detailed.vue';
import Tenancies from '@/components/Tenancies.vue';

export default Vue.extend({
  name: 'Thanks',
  components: {
    PageTemplate,
    BlockContainer,
    HusleieLogo,
    Card,
    Detailed,
    Tenancies,
  },
  computed: {
    ...mapGetters(['getAllTenancies']),

    filteredTenancies() {
      return this.getAllTenancies.filter(tenancy => {
        if (tenancy.status === 'shadow') {
          return false;
        }
        const product = tenancy.products.find(prod => prod.name === 'rentadm');

        if (!product || (product && product.level !== 'premium')) {
          return true;
        }
        return false;
      });
    },

    benefitsBasic() {
      return {
        title: 'Alt i Gratis, pluss:',
        items: [
          'Fakturering av husleien',
          'Betalingsoppfølging',
          'Bistand til utkastelse',
          'Depositumskonto',
          'Telefonsupport',
          'Advokat (750,- 15min)',
        ],
      };
    },
    benefitsPremium() {
      return {
        title: 'Alt i Basic, pluss:',
        items: [
          'Indeksregulering',
          'Forsikring mot ubet. leie*',
          'Boligskadeforsikring*',
          'Merutgifter utkastelse*',
          'Advokat (1t / år)',
        ],
      };
    },
    detailedBenefits() {
      return [
        {
          benefit: 'Leiekontrakt m/ BankID',
          active: [true, true, true],
        },
        {
          benefit: 'Min side',
          active: [true, true, true],
        },
        {
          benefit: 'Overtakelsesprotokoll',
          active: [true, true, true],
        },
        {
          benefit: 'Annonsering til FINN.no ***',
          active: [true, true, true],
        },
        {
          benefit: 'Oppsigelse og heving',
          active: [true, true, true],
        },
        {
          benefit: 'Juridisk bistand',
          active: [false, '750 kr/15 min', '1t/år'],
        },
        {
          benefit: 'SMS-utsendelse',
          active: [false, true, true],
        },
        {
          benefit: 'Kundeservice',
          active: [false, true, true],
        },
        {
          benefit: 'Fakturering av husleien (auto)',
          active: [false, true, true],
        },
        {
          benefit: 'Purring og inkasso (auto)',
          active: [false, true, true],
        },
        {
          benefit: 'Depositumskonto*',
          active: ['Kr 599,-', true, true],
        },
        {
          benefit: 'Indeksregulering',
          active: [false, false, true],
        },
        {
          benefit: 'Boligskade opp til kr 500 000 *',
          active: [false, false, true],
        },
        {
          benefit: 'Tapt husleie opp til 6 mnd **',
          active: [false, false, true],
        },
        {
          benefit: 'Merutgifter utkastelse **',
          active: [false, false, true],
        },
      ];
    },
  },
  methods: {
    ...mapActions(['fetchData']),
  },
  created() {
    this.fetchData({
      tenancies: ['active', 'free'],
    });
  },
});
</script>

<style lang="scss" scoped>
.thanks__benefitCards {
  display: flex;
  flex-direction: column;
  gap: 2rem 0rem;
}
.thanks__benefitCards > :last-child {
  border-top: 30px solid $light;
}
.thanks__detailedBenefits {
  display: none;
}
.thanks__tenancies {
  margin-top: 1.8rem;
  padding: 2rem;
}

@media (min-width: 500px) {
  .thanks__benefitCards {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 0rem 1rem;
  }
  .thanks__benefitCards > :last-child {
    border: 0;
  }
  .thanks__detailedBenefits {
    display: flex;
    flex-direction: column;
    padding: 0rem 14rem;
    margin-top: 8rem;
  }
  .thanks__tenancies {
    margin-top: 3rem;
    padding: 2rem;
  }
}
</style>
